<div *ngIf="{lines: lines$ | async} as data">
  <div>
    <mat-nav-list [@enterAnimation] *ngIf="data.lines && data.lines.length > 0">
      <ng-container *ngFor="let line of data.lines;let i = index">
        <mat-list-item class="mat-list-item-word-wrap" (click)="displayEditCase(line)">
          <div mat-list-icon class="icon-container">
            <mat-icon>build</mat-icon>
          </div>
          <h3 mat-line>{{line.warrantySubmissionTypeId}} recommended at
            {{line.recommendedHours ? line.recommendedHours : '0'}} hours quoted by
            {{line?.embedded?.employeeAssociate?.firstName + ' ' + line?.embedded?.employeeAssociate?.lastName}}
          </h3>
          <p mat-line>The quote for {{line.totalAmount | currency}} Expires on
            {{line.expirationDate | moment: 'MMM DD, YYYY'}}
          </p>
          <p mat-line class="secondary-line">{{line.serviceName}}
          </p>
        </mat-list-item>
        <mat-divider inset *ngIf="i+1 < data.lines.length"></mat-divider>
      </ng-container>
    </mat-nav-list>
  </div>

</div>